import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Flex, Button, TextField } from "@radix-ui/themes";
import { PlusIcon, MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { PageLayoutV2 } from "@/v2/components/layout/page-layout/PageLayout";
import { PageHeader } from "@/v2/components/layout";
import { TabItem, Tabs } from "@/v2/components/tabs/Tabs";
import { AiVisionRecognition } from "@/v2/assets/icons/AiVisionRecognition";
import { PageColors, ENavigate } from "@/components/sidebar/sidebar.types";
import { QualitySearchProvider, useQualitySearch } from "./QualitySearchContext";

const tabs: TabItem[] = [
  { value: "evaluations", label: "Evaluations" },
  { value: "validations", label: "Validations" },
  { value: "scorecards", label: "Scorecards" },
];

function QualityPageContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { searchPhrase, setSearchPhrase } = useQualitySearch();

  const selectedTab = location.pathname.split("/").pop();
  const onTabChange = (value: string) => {
    navigate(`/quality/${value}`);
  };

  return (
    <PageLayoutV2>
      <Flex direction="column">
        <PageHeader
          title="Quality Assurance"
          description="Monitor and improve AI performance through evaluations, validations, and scorecards."
          icon={<AiVisionRecognition size={24} fill={PageColors[ENavigate.QUALITY] || "gray"} />}
          actions={
            selectedTab === "scorecards" ? (
              <Flex gap="2" align="center">
                <TextField.Root
                  placeholder="Search scorecards"
                  size="2"
                  value={searchPhrase}
                  onChange={(e) => setSearchPhrase(e.target.value)}
                >
                  <TextField.Slot>
                    <MagnifyingGlassIcon height="16" width="16" />
                  </TextField.Slot>
                </TextField.Root>
                <Button
                  highContrast
                  color="gray"
                  onClick={() => navigate("/quality/scorecards/new")}
                >
                  <PlusIcon />
                  Create Scorecard
                </Button>
              </Flex>
            ) : undefined
          }
        />

        <Flex px={"6"} direction="column">
          <Tabs tabs={tabs} value={selectedTab} onValueChange={onTabChange} />
        </Flex>

        <Outlet />
      </Flex>
    </PageLayoutV2>
  );
}

export function QualityPage() {
  return (
    <QualitySearchProvider>
      <QualityPageContent />
    </QualitySearchProvider>
  );
}
